import axios from "axios"
import { JSONData } from "src/assets/json"
import { APIURL } from "src/config/helpers/base"

// export const setDataDataset = (rows = 10, pageNum = 1, sort = 1, search = '', tag = '') => {
//     return (dispatch) => {
//         dispatch({ type: 'DATAS', payload: false })
//         axios.get(`${APIURL}/dataset/GetDatasets?Tag=${tag}&Rows=${rows}&PageNum=${pageNum}`).then(res => {
//             var data = res.data;
//             if (data.IsSuccess) {
//                 setTimeout(() => {
//                     dispatch({ type: 'DATAS', payload: data.Data.Datasets })
//                     dispatch({ type: 'TOT_PAGE_DATAS', payload: data.Data.TotPage })
//                     dispatch({ type: 'TOT_RESULT_DATAS', payload: data.Data.TotResult })
//                 }, 3000);
//             } else {

//             }
//         })
//     }
// }

export const setDataAgencyDataset = (pageNum = 1, sort = '', search = '', tag = '', rows = '10') => {
    return (dispatch) => {
        dispatch({ type: 'DATA_ORGANISASIS', payload: false })
        axios.get(`${APIURL}/Agency/GetDataset?PageNum=${pageNum}&Sort=${sort}&Search=${search}&Tag=${tag}&Rows=${rows}`).then(res => {
            var data = res.data;
            if (data.IsSuccess) {
                setTimeout(() => {
                    dispatch({ type: 'DATA_ORGANISASIS', payload: data.Data.Agencies })
                    dispatch({ type: 'TOT_RESULT_ORGANISASIS', payload: data.Data.TotResult })
                }, 3000);
            } else {
                dispatch({ type: 'DATA_ORGANISASIS', payload: [] })
                dispatch({ type: 'TOT_RESULT_ORGANISASIS', payload: 0 })
            }
        })
    }
}


// export const setDataAgencyDatasetBySlug = (slug, rows = 10, pageNum = 1, sort = 1, search = '', tag = '') => {
//     return (dispatch) => {
//         dispatch({ type: 'DATA', payload: false })
//         axios.get(`${APIURL}/agency/GetDatasetByUrlFiendly?Slug=${slug}&Tag=${tag}&Rows=${rows}&PageNum=${pageNum}`).then(res => {
//             var data = res.data;
//             if (data.IsSuccess) {
//                 setTimeout(() => {
//                     dispatch({ type: 'DATA', payload: data.Data })
//                 }, 3000);
//             } else {

//             }
//         })
//     }
// }

export const setFormSearchDatas = (formType, formValue) => {
    return { type: 'FORM_SEARCH_DATAS', formType, formValue }
}

export const setDatas = (rows = 10, pageNum = 1, sort = 1, search = '', tag = '') => {
    return (dispatch) => {
        dispatch({ type: 'DATAS', payload: false })
        axios.get(`${APIURL}/Api/Opd/GetOpds?Rows=${rows}&PageNum=${pageNum}&sort=${sort}&search=${search}&tag=${tag}`).then(res => {
            var data = res.data;
            if (data.IsSuccess) {
                setTimeout(() => {
                    dispatch({ type: 'DATAS', payload: data.Data.Opds })
                    dispatch({ type: 'TOT_PAGE_DATAS', payload: data.Data.TotPage })
                    dispatch({ type: 'TOT_RESULT_DATAS', payload: data.Data.TotResult })
                }, 3000);
            } else {
                dispatch({ type: 'DATAS', payload: [] })
                dispatch({ type: 'TOT_PAGE_DATAS', payload: 0 })
                dispatch({ type: 'TOT_RESULT_DATAS', payload: 0 })
            }
        })
    }
}

export const setData = (url) => {
    return (dispatch) => {
        dispatch({ type: 'DATA', payload: false })
        axios.get(`${APIURL}/Api/Opd/GetOpd?Url=${url}`).then(res => {
            var data = res.data;
            if (data.IsSuccess) {
                setTimeout(() => {
                    dispatch({ type: 'DATA', payload: data.Data })
                }, 3000);
            } else {

            }
        })
    }
}

export const setDataSumberDatas = (url, pageNum = 1) => {
    return (dispatch) => {
        axios.get(`${APIURL}/Api/Opd/GetOpdSumberData?Url=${url}&PageNum=${pageNum}`).then(res => {
            var data = res.data;
            if (data.IsSuccess) {
                dispatch({ type: 'DATA_SUMBER_DATAS', payload: data.Data.SumberData })
                dispatch({ type: 'TOT_PAGE_SUMBER_DATAS', payload: data.Data.TotPage })
                dispatch({ type: 'TOT_RESULT_SUMBER_DATAS', payload: data.Data.TotResult })
            } else {

            }
        })
    }
}

export const setDataOrganisasis = (pageNum = 1, sort = '', search = '') => {
    return (dispatch) => {
        dispatch({ type: 'DATA_ORGANISASIS', payload: false })
        axios.get(`${APIURL}/Api/Organisasi/GetWebOrganisasis?PageNum=${pageNum}&Sort=${sort}&Search=${search}`).then(res => {
            var data = res.data;
            if (data.IsSuccess) {
                setTimeout(() => {
                    dispatch({ type: 'DATA_ORGANISASIS', payload: data.Data.Organisasis })
                    dispatch({ type: 'TOT_RESULT_ORGANISASIS', payload: data.Data.TotResult })
                }, 3000);
            } else {
                dispatch({ type: 'DATA_ORGANISASIS', payload: [] })
                dispatch({ type: 'TOT_RESULT_ORGANISASIS', payload: 0 })
            }
        })
    }
}

export const setDataOrganisasi = (url) => {
    return (dispatch) => {
        dispatch({ type: 'DATA_ORGANISASI', payload: false })
        axios.get(`${APIURL}/Api/Organisasi/GetWebOrganisasi?Url=${url}`).then(res => {
            var data = res.data;
            if (data.IsSuccess) {
                dispatch({ type: 'DATA_ORGANISASI', payload: data.Data })
            } else {

            }
        })
    }
}